import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { NotifyService } from "../services/notify-service";
import { SecurityConfigService } from "../services/security-config-service";

export function RLCharacteristicPolicyEditor() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/characteristic-policy-editor.html"),
        controller: RLCharacteristicPolicyEditorController,
        bindToController: true,
        controllerAs: "cpeVM",
        scope: {
            charTypeID: "=charTypeId",
            templateGroupID: "=templateGroupId",
            templateID: "=templateId",
            charGroupID: "=charGroupId",
            charID: "=charId",
            systemIndicator: "=",
            visibilityIndicator: "=",
            tagLabel: "=",
            contextPermissions: "=permissions"
        }
    };
    return directive;
}


export class RLCharacteristicPolicyEditorController {
    static $inject = ["$scope", "notifyService", "securityConfigService"];

    charTypeID: number;
    templateGroupID: number;
    templateID: number;
    charGroupID: number;
    charID: number;
    systemIndicator: number;
    visibilityIndicator: number;

    tagLabel: string;

    securityRights = [
        {
            name: "Read",
            rightFlag: Consts.AccessRight.Read
        },
        {
            name: "Write",
            rightFlag: Consts.AccessRight.Write
        },
        {
            name: "Create",
            rightFlag: Consts.AccessRight.Create
        },
        {
            name: "Delete",
            rightFlag: Consts.AccessRight.Delete
        },
        //{
        //    name: "Admin",
        //    rightFlag: Consts.AccessRight.Admin
        //}
    ];

    policies: Models.IAspNetSecurityPolicy[];
    permissions: _.Dictionary<Models.IAspNetSecurityPolicyPermission[]>;
    acls: _.Dictionary<string[]>;

    rightStatus: _.Dictionary<_.Dictionary<number>>;
    effectiveClass: _.Dictionary<_.Dictionary<string>>;

    contextPermissions: _.Dictionary<Models.IAspNetSecurityPolicyPermission>;
    loaded = false;

    constructor(private $scope: ng.IScope, private notifyService: NotifyService, private securityConfigService: SecurityConfigService) {

        $scope.$watchGroup([() => this.charTypeID, () => this.templateGroupID, () => this.templateID, () => this.charGroupID, () => this.charID, () => this.systemIndicator, () => this.visibilityIndicator],
            (newValue, oldValue) => {
                if (!this.loaded && newValue[0] != null && newValue[1] != null && newValue[2] != null && newValue[3] != null && newValue[5] != null && newValue[6] != null) {
                    this.Load();
                }
            });

        $scope.$watch(() => this.systemIndicator, (newValue, oldValue) => {
            if (newValue == -1 && oldValue != -1 && this.loaded) {
                if (this.tagLabel != "entity_title") {
                    this.SetAsInternal();
                    this.UpdateStatus();
                }
            }
        });
    }

    GetEffectiveStatusClass(effectiveStatus: number) {
        var output = "effective-neutral";
        switch (effectiveStatus) {
            case 1:
                output = "success";
                break;
            case -1:
                output = "danger";
                break;
        }
        return output;
    }

    Load() {
        this.notifyService.startProgress();
        return this.securityConfigService.getCharacteristicPolicySummary(this.charTypeID, this.templateGroupID, this.templateID, this.charGroupID, this.charID)
            .then((result) => {
                this.policies = result.policies;
                this.permissions = result.permissions;
                this.acls = _.transform(this.permissions, (acc, value, key) => acc[key] = value.map(p => this.PermissionToAcl(p)), <_.Dictionary<string[]>>{});
                this.SetContextFromAcls();
                this.UpdateStatus();
            })
            .then(() => {
                this.loaded = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    SetContextFromAcls() {
        this.contextPermissions = _.transform(this.permissions, (acc, value, key) => acc[key] = _.clone(_.find(value, p => p.charTypeID == this.charTypeID && p.templateGroupID == this.templateGroupID && p.templateID == this.templateID && p.charGroupID == this.charGroupID && p.charID == this.charID)) || null, <_.Dictionary<Models.IAspNetSecurityPolicyPermission>>{});
        if (this.systemIndicator == -1 && this.tagLabel != "entity_title") {
            this.SetAsInternal();
        }
    }

    PermissionToAcl(permission: Models.IAspNetSecurityPolicyPermission) {
        var p = permission;
        return Utils.AclUtil.withPermissionValue(Utils.AclUtil.getDataEntityAcl(p.charTypeID, p.templateGroupID, p.templateID, p.charGroupID, p.charID), p.permissionValue);
    }

    GetCharAcl() {
        return Utils.AclUtil.getDataEntityAcl(this.charTypeID, this.templateGroupID, this.templateID, this.charGroupID, this.charID);
    }

    GetEffectiveAcls(policyID: string) {
        var acls = this.acls[policyID]
        if (this.contextPermissions[policyID] != null) {
            var contextAcl = this.PermissionToAcl(this.contextPermissions[policyID]);
            var aclIndex = _.findIndex(acls, acl => acl.split("?")[0] == contextAcl.split("?")[0]);
            if (aclIndex >= 0) {
                acls[aclIndex] = contextAcl;
            } else {
                acls = [...acls, contextAcl];
            }
        }
        return acls;
    }

    UpdateStatus() {
        this.rightStatus = {};
        this.effectiveClass = {};

        var charAcl = this.GetCharAcl();

        this.policies.forEach(p => {
            // reset lookup dictionaries
            this.rightStatus[p.securityPolicyID] = {};
            this.effectiveClass[p.securityPolicyID] = {};
            // get acls including any being edited/created in this context
            var effectiveAcls = this.GetEffectiveAcls(p.securityPolicyID);
            // get hierarchical permission value
            var effectivePermissionValue = Utils.AclUtil.getEffectivePermissionValue(effectiveAcls, charAcl);
            // get permission for this exact CharID
            var contextPermission = this.contextPermissions[p.securityPolicyID];

            this.securityRights.forEach(s => {
                // get status for this CahrID exactly
                var contextStatus = Utils.SecurityUtil.GetRightStatus(contextPermission != null ? contextPermission.permissionValue : 0, s.rightFlag);
                // get status across all acls
                var effectivePermissionStatus = Utils.SecurityUtil.GetRightStatus(effectivePermissionValue, s.rightFlag);
                this.rightStatus[p.securityPolicyID][s.rightFlag] = contextStatus;
                this.effectiveClass[p.securityPolicyID][s.rightFlag] = this.GetEffectiveStatusClass(effectivePermissionStatus);
            });
        });
    }

    Toggle(policy: Models.IAspNetSecurityPolicyPermission, rightFlag: number) {
        if (this.contextPermissions[policy.securityPolicyID] == null) {
            this.contextPermissions[policy.securityPolicyID] = this.CreateNewPermission(policy.securityPolicyID);
        }
        var permission = this.contextPermissions[policy.securityPolicyID];
        var currentRightStatus = Utils.SecurityUtil.GetRightStatus(permission.permissionValue, rightFlag);
        var newStatus = 0;
        if (currentRightStatus == 0) {
            // currently nuetral, set to allow
            newStatus = 1;
        } else if (currentRightStatus == 1) {
            // currently allow, set to deny
            newStatus = -1;
        } else if (currentRightStatus == -1) {
            // currently deny, set to nuetral
            newStatus = 0;
        }
        permission.permissionValue = Utils.SecurityUtil.SetRightStatus(permission.permissionValue, rightFlag, newStatus);
        if (permission.permissionValue === 0) {
            //this.RemovePermission(permission);
            this.contextPermissions[policy.securityPolicyID] = null;
        }

        this.UpdateStatus();
    }

    SetAsHidden() {
        this.contextPermissions = _.transform(this.contextPermissions, (acc, value, securityPolicyID) => {
            var permission = value || this.CreateNewPermission(securityPolicyID);
            permission.permissionValue = Utils.SecurityUtil.SetRightStatus(permission.permissionValue, Consts.AccessRight.All, -1);
            acc[securityPolicyID] = permission;
        }, <_.Dictionary<Models.IAspNetSecurityPolicyPermission>>{});
    }

    SetAsInternal() {
        this.contextPermissions = _.transform(this.contextPermissions, (acc, value, securityPolicyID) => {
            var permission = value || this.CreateNewPermission(securityPolicyID);
            var allButRead = Consts.AccessRight.Write | Consts.AccessRight.Create | Consts.AccessRight.Delete | Consts.AccessRight.Admin;
            permission.permissionValue = Utils.SecurityUtil.SetRightStatus(permission.permissionValue, allButRead, -1);
            acc[securityPolicyID] = permission;
        }, <_.Dictionary<Models.IAspNetSecurityPolicyPermission>>{});
    }


    private CreateNewPermission(securityPolicyID: string): Models.IAspNetSecurityPolicyPermission {
        return { permissionValue: 0, charTypeID: this.charTypeID, templateGroupID: this.templateGroupID, templateID: this.templateID, charGroupID: this.charGroupID, charID: this.charID, securityPolicyID: securityPolicyID, securityPolicyPermissionID: null };
    }

    Reset() {
        this.SetContextFromAcls();
        this.UpdateStatus();
    }

    SetAll($event: Event, rightFlag: number, status: number) {
        $event.preventDefault();
        for (var i = 0; i < this.policies.length; i++) {
            var policy = this.policies[i];
            if (this.contextPermissions[policy.securityPolicyID] == null) {
                if (status == 0) {
                    // skip if not found and setting to neutral 
                    continue;
                } else {
                    this.contextPermissions[policy.securityPolicyID] = this.CreateNewPermission(policy.securityPolicyID);
                }
            }
            var permission = this.contextPermissions[policy.securityPolicyID];
            permission.permissionValue = Utils.SecurityUtil.SetRightStatus(permission.permissionValue, rightFlag, status);
            if (permission.permissionValue === 0 || permission.permissionValue == Consts.AccessRight.Admin << 16) {
                //this.RemovePermission(permission);
                this.contextPermissions[policy.securityPolicyID] = null;
            }
        }
        this.UpdateStatus();
    }
}
